const adjustColor = (hex, amount) => {
    return ('#' +
        (hex === null || hex === void 0 ? void 0 : hex.replace(/^#/, '').match(/.{1,2}/g).map((x) => {
            const c = parseInt(x, 16) + amount;
            const clamped = Math.max(0, Math.min(255, c));
            return clamped.toString(16).padStart(2, '0');
        }).join('')));
};
export default adjustColor;
